<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import type { ICommentDTO } from "../../services/DTO";
  import { formatTimestampHuman } from "../../utils/date-utils";
  import Textarea from "../Form/Fields/Textarea.svelte";
  import FormField from "../Form/FormField.svelte";
  import Icon from "../Icon.svelte";

  export let comments: ICommentDTO[] = [];
  export let entityId: number = 0;
  export let disabled: boolean = false;

  let commentOid = 0;
  let commentText = "";

  const dispatch = createEventDispatcher();

  function onLoad() {
    dispatch("load", { entityId: entityId });
  }

  function onEdit(comment: ICommentDTO) {
    commentOid = comment.oid;
    commentText = comment.commentText;
  }

  function onSave() {
    let comment = {
      oid: commentOid,
      entityId: entityId,
      commentText: commentText,
    } as ICommentDTO;
    dispatch("save", comment);
    commentOid = 0;
    commentText = "";
  }

  function onDelete(comment: ICommentDTO) {
    dispatch("delete", comment);
  }

  onMount(() => onLoad());
</script>

<div class="box">
  <h1 class="subtitle">Commenti</h1>
  <FormField>
    <Textarea
      placeholder="aggiungi commento"
      required={false}
      {disabled}
      rows={2}
      multiline={false}
      on:enter={onSave}
      bind:value={commentText}
    />
  </FormField>

  {#each comments as comment}
    <hr class="comment-separator" />
    <div class="comment-info">
      <span>
        <Icon
          name="edit"
          customRealIconStyle="font-size:18px;width:18px;"
          on:click={(_) => onEdit(comment)}
        />
        <Icon
          name="delete"
          customRealIconStyle="font-size:18px;width:18px;"
          on:click={(_) => onDelete(comment)}
        />
      </span>
      <span class="comment-info-text">
        {#if comment.updatedBy != ""}
          {formatTimestampHuman(comment.updatedOn)} - {comment.updatedBy}
        {:else}
          {formatTimestampHuman(comment.updatedOn)}
        {/if}
      </span>
    </div>
    <div class="content">
      <!--
      {@html comment.commentText.replace(/\n/g, '<br>')}
      -->
      {comment.commentText}
    </div>
  {/each}
</div>

<style>
  .comment-separator {
    margin: 4px 0;
  }
  .comment-info {
    position: relative;
  }
  .comment-info-text {
    color: #999;
    font-size: x-small;
    display: inline-block;
    position: absolute;
    top: 4px;
    margin-left: 5px;
  }
</style>
